module.exports = __webpack_public_path__ + "img/tab_add.58417135.svg";